var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneBlueCircle = function SvgPhoneBlueCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E6F4FF",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.983 17.378c.58 1.208 1.37 2.34 2.372 3.341a12.17 12.17 0 0 0 3.342 2.372c.104.05.155.075.221.094.234.068.52.02.719-.122.055-.04.103-.088.198-.183.291-.291.437-.437.584-.532a1.667 1.667 0 0 1 1.817 0c.146.095.292.24.583.532l.163.162c.442.443.664.665.784.902.24.473.24 1.032 0 1.505-.12.238-.342.46-.784.902l-.132.131c-.441.442-.662.662-.962.831-.333.187-.85.322-1.232.32-.344 0-.58-.067-1.05-.201a15.865 15.865 0 0 1-6.903-4.061 15.865 15.865 0 0 1-4.06-6.903c-.134-.47-.201-.706-.202-1.05a2.815 2.815 0 0 1 .32-1.232c.169-.3.39-.52.83-.962l.132-.131c.443-.443.664-.665.902-.785a1.667 1.667 0 0 1 1.505 0c.238.12.46.342.902.785l.162.162c.292.291.437.437.533.584.359.552.359 1.264 0 1.817-.096.146-.241.292-.533.583-.095.095-.143.143-.182.199a.872.872 0 0 0-.123.718c.02.066.044.118.094.222Z"
  })));
};
export default SvgPhoneBlueCircle;